'use client'

import React from 'react'
import { useTranslations } from 'next-intl'

import useFormatDate from '@/src/hooks/date/useFormatDate'
import { RecentSearchListItem } from '@/src/hooks/srp/recentSearch'
import { convertToUSDateFormat } from '@/src/utils/date/convertDateFormat'
import { RecentSearchBlock } from './recentSearchBlock'
import type { RecentSearchBlockProps } from './recentSearchBlock'

interface RecentSearchBlockWrapperProps {
    item: RecentSearchListItem & { onClick?: () => void }
}

const RecentSearchBlockWrapper: React.FC<RecentSearchBlockWrapperProps> = ({ item }) => {
    const tCommon = useTranslations('common')
    const { formatDate } = useFormatDate()

    if (!item) return null

    const adults = item.adults || 0
    const childs = item.childs || 0
    const infants = item.infants || 0
    const totalTraveler = item.numberOfPax || adults + childs + infants
    const isSinglePerson = totalTraveler < 2
    const tripType = item.returnDate ? tCommon('roundTrip') : tCommon('oneWay')
    const travelClass = item?.flightClass ? tCommon(item.flightClass as any) : ''
    const departDate = formatDate(convertToUSDateFormat(item.departDate), 'DD MMM, YYYY')
    const returnDate = item.returnDate
        ? formatDate(convertToUSDateFormat(item.returnDate), 'DD MMM, YYYY')
        : ''
    const travellerLabel = tCommon('traveller', { s: isSinglePerson ? '' : 's' })

    return (
        <RecentSearchBlock
            from={item.from}
            to={item.to}
            fromCity={item.fromCity}
            toCity={item.toCity}
            tripType={tripType}
            departDate={departDate}
            returnDate={returnDate}
            totalTraveler={totalTraveler}
            travelClass={travelClass}
            isSinglePerson={isSinglePerson}
            travellerLabel={travellerLabel}
            onClick={item.onClick}
        />
    )
}

export { RecentSearchBlock }
export type { RecentSearchBlockProps }
export { RecentSearchBlockWrapper }

